import { EmailType } from "@repo/server-api";

/**
 * Frontend model for BCC Recipient List
 * This is the UI representation, independent of the backend model
 */
export type BccRecipientListModel = {
	contractorId: string;
	type: EmailType;
	recipients: string[];
};

/**
 * Supported email types for BCC recipients
 */
export const SUPPORTED_EMAIL_TYPES = [
	EmailType.Invoice,
	EmailType.Offer,
	EmailType.Reminder,
	EmailType.CreditNote,
] as const;
